export default __webpack_public_path__ + "static/guilherme-gabriel-8de8eef572d3b8ca0f42dda396a692ec.jpg";